import { useEffect, useState } from "react";
import "@/App.css";
import Lenis from "lenis";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { Navbar } from "@/components/Navbar";
import { AdminDashboard } from "@/components/AdminDashboard";
import { Hero } from "@/components/Hero";
import { Marquee } from "@/components/Marquee";
import { Calculator } from "@/components/Calculator";
import { Professions } from "@/components/Professions";
import { Steps } from "@/components/Steps";
import { GeorgiaStrip } from "@/components/GeorgiaStrip";
import { Officer } from "@/components/Officer";
import { Faq } from "@/components/Faq";
import { Footer } from "@/components/Footer";
import { QualifyModal } from "@/components/QualifyModal";

function Landing() {
  const [modalOpen, setModalOpen] = useState(false);

  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09 });
    window.__lenis = lenis;
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  const openModal = () => setModalOpen(true);

  return (
    <div className="bg-[#FAF8F5] font-body text-[#0B162C] antialiased">
      <Navbar onQualify={openModal} />
      <main>
        <Hero onQualify={openModal} />
        <Marquee />
        <Calculator onQualify={openModal} />
        <Professions />
        <Steps onQualify={openModal} />
        <GeorgiaStrip />
        <Officer onQualify={openModal} />
        <Faq />
      </main>
      <Footer />
      <QualifyModal open={modalOpen} onClose={() => setModalOpen(false)} />
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/admin" element={<AdminDashboard />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
